import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      "max-width": "1200px",
      "scrollable": ""
    },
    model: {
      value: _vm.internalOpen,
      callback: function ($$v) {
        _vm.internalOpen = $$v;
      },
      expression: "internalOpen"
    }
  }, [_c(VCard, [_c(VCardTitle, {
    class: `headline ${_vm.color}--text`
  }, [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "left": ""
    }
  }, [_vm._v("fal fa-calendar-alt")]), _vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.history.title')) + "\n      "), _c(VSpacer), _c(VBtn, {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c(VIcon, [_vm._v("fal fa-times")])], 1)], 1), _vm.rule ? _c(VCardSubtitle, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.history.subtitle', {
    name: _vm.rule.name,
    type: _vm.getRuleTypeName(_vm.rule.ruleType)
  })) + "\n    ")]) : _vm._e(), _c(VDivider), _c(VCardText, {
    staticClass: "pa-0"
  }, [_c(VDataTable, {
    attrs: {
      "loading": _vm.loading,
      "items": _vm.events,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "sort-by": ['timestamp'],
      "sort-desc": [true],
      "item-key": "timestamp"
    },
    scopedSlots: _vm._u([{
      key: "item.timestamp",
      fn: function ({
        item
      }) {
        return [_vm._v("\n          " + _vm._s(_vm.formatTimestamp(item.timestamp)) + "\n        ")];
      }
    }, {
      key: "item.eventType",
      fn: function ({
        item
      }) {
        return [_c(VChip, {
          attrs: {
            "color": _vm.getEventColor(item.eventType, item.severity),
            "small": "",
            "outlined": ""
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t(`Connectors.Monitoring.rules.eventTypes.${item.eventType.toUpperCase()}`)) + "\n          ")])];
      }
    }, {
      key: "item.severity",
      fn: function ({
        item
      }) {
        return [item.severity ? _c(VIcon, {
          attrs: {
            "small": "",
            "color": _vm.getSeverityColor(item.severity),
            "title": _vm.$i18n_t(`Connectors.Monitoring.rules.severity.${item.severity.toLowerCase()}`)
          }
        }, [_vm._v("\n            fa fa-exclamation-triangle\n          ")]) : _c('span', [_vm._v("-")])];
      }
    }, {
      key: "item.details",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticStyle: {
            "white-space": "normal",
            "word-break": "break-word",
            "line-height": "1.5",
            "padding": "8px 0"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.formatDetails(item)) + "\n          ")])];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n          " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n        ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_vm.error ? _c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-exclamation-triangle"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.error) + "\n          ")]) : _c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.rules.history.empty')) + "\n          ")])];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };